import { makeStyles } from "tss-react/mui"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import {
    fetchMerchantSalesDetails,
    SupplierMerchantSalesDetailsResponse,
    SupplierMerchantSalesQuery,
} from "../merchantSalesApi"
import { useSupplier } from "../../../../supplierHooks"
import { Grid, Skeleton, Stack } from "@mui/material"
import { DetailedTable } from "./DetailedCategoryTable"

const useStyles = makeStyles()(() => ({
    container: {
        paddingLeft: "3rem",
    },
}))

function transformData(data: SupplierMerchantSalesDetailsResponse) {
    return data.merchants
}

export function DetailedPanel({ shopTypes, merchantId }: { merchantId: number; shopTypes?: Array<string> }) {
    const { supplierId } = useSupplier()
    const { classes } = useStyles()

    const merchantSalesDetailsResult = useApiQuery(fetchMerchantSalesDetails, {
        queryName: SupplierMerchantSalesQuery.MERCHANT_SALES_FOR_SUPPLIER_DETAILS,
        dependencies: {
            supplierId,
            merchantId,
            shopTypes: shopTypes?.join(","),
        },
        select: transformData,
    })

    return (
        <Grid container className={classes.container}>
            <Grid item xs={10}>
                {merchantSalesDetailsResult.isLoading ? (
                    <Stack direction="column" spacing="1rem">
                        <Skeleton variant="rectangular" animation="wave" />
                        <Skeleton variant="rectangular" animation="wave" />
                        <Skeleton variant="rectangular" animation="wave" />
                    </Stack>
                ) : (
                    <Stack direction="column" spacing="1rem">
                        {merchantSalesDetailsResult.data?.salesByAccount.categories.map((category) => (
                            <DetailedTable
                                key={category.name}
                                isError={merchantSalesDetailsResult.isError}
                                isFetching={merchantSalesDetailsResult.isFetching}
                                isInitialLoading={merchantSalesDetailsResult.isInitialLoading}
                                category={category}
                            />
                        ))}
                    </Stack>
                )}
            </Grid>
        </Grid>
    )
}
